export const incidentR = {
  Jun: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        FIELD3: 31,
        Mean: 42,
        "0330": 108,
        "0430": 160,
        "0530": 102,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 102,
        1730: 160,
        1830: 108,
        1930: 42,
        2030: "",
      },
      Diffuse: {
        Type: "Diffuse",
        FIELD3: 68,
        Mean: 15,
        "0330": 38,
        "0430": 73,
        "0530": 96,
        "0630": 109,
        "0730": 118,
        "0830": 124,
        "0930": 130,
        1030: 131,
        1130: 131,
        1230: 130,
        1330: 124,
        1430: 118,
        1530: 109,
        1630: 96,
        1730: 73,
        1830: 38,
        1930: 15,
        2030: "",
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        FIELD3: 83,
        Mean: 67,
        "0330": 200,
        "0430": 410,
        "0530": 472,
        "0630": 429,
        "0730": 313,
        "0830": 153,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: "",
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 73,
        Mean: 20,
        "0330": 52,
        "0430": 104,
        "0530": 139,
        "0630": 154,
        "0730": 155,
        "0830": 149,
        "0930": 145,
        1030: 139,
        1130: 133,
        1230: 126,
        1330: 116,
        1430: 105,
        1530: 89,
        1630: 71,
        1730: 50,
        1830: 25,
        1930: 10,
        2030: "",
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        FIELD3: 135,
        Mean: 54,
        "0330": 175,
        "0430": 419,
        "0530": 566,
        "0630": 616,
        "0730": 580,
        "0830": 471,
        "0930": 305,
        1030: 106,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: "",
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 79,
        Mean: 18,
        "0330": 48,
        "0430": 106,
        "0530": 153,
        "0630": 180,
        "0730": 188,
        "0830": 180,
        "0930": 169,
        1030: 156,
        1130: 144,
        1230: 131,
        1330: 117,
        1430: 104,
        1530: 88,
        1630: 70,
        1730: 48,
        1830: 23,
        1930: 9,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        FIELD3: 127,
        Mean: 9,
        "0330": 47,
        "0430": 183,
        "0530": 328,
        "0630": 443,
        "0730": 507,
        "0830": 513,
        "0930": 458,
        1030: 350,
        1130: 201,
        1230: 26,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 78,
        Mean: 11,
        "0330": 32,
        "0430": 75,
        "0530": 120,
        "0630": 156,
        "0730": 178,
        "0830": 184,
        "0930": 182,
        1030: 173,
        1130: 162,
        1230: 148,
        1330: 129,
        1430: 110,
        1530: 89,
        1630: 69,
        1730: 48,
        1830: 24,
        1930: 9,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        FIELD3: 94,
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 10,
        "0730": 137,
        "0830": 255,
        "0930": 343,
        1030: 390,
        1130: 390,
        1230: 343,
        1330: 255,
        1430: 137,
        1530: 10,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 76,
        Mean: 9,
        "0330": 23,
        "0430": 51,
        "0530": 80,
        "0630": 110,
        "0730": 138,
        "0830": 158,
        "0930": 172,
        1030: 176,
        1130: 176,
        1230: 172,
        1330: 158,
        1430: 138,
        1530: 110,
        1630: 80,
        1730: 51,
        1830: 23,
        1930: 9,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        FIELD3: 127,
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 26,
        1030: 201,
        1130: 350,
        1230: 458,
        1330: 513,
        1430: 507,
        1530: 443,
        1630: 328,
        1730: 183,
        1830: 47,
        1930: 9,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 78,
        Mean: 9,
        "0330": 24,
        "0430": 48,
        "0530": 69,
        "0630": 89,
        "0730": 110,
        "0830": 129,
        "0930": 148,
        1030: 162,
        1130: 173,
        1230: 182,
        1330: 184,
        1430: 178,
        1530: 156,
        1630: 120,
        1730: 75,
        1830: 32,
        1930: 11,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        FIELD3: 135,
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 106,
        1230: 305,
        1330: 471,
        1430: 580,
        1530: 616,
        1630: 566,
        1730: 419,
        1830: 175,
        1930: 54,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 79,
        Mean: 9,
        "0330": 23,
        "0430": 48,
        "0530": 70,
        "0630": 88,
        "0730": 104,
        "0830": 117,
        "0930": 131,
        1030: 144,
        1130: 156,
        1230: 169,
        1330: 180,
        1430: 188,
        1530: 180,
        1630: 153,
        1730: 106,
        1830: 48,
        1930: 18,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        FIELD3: 83,
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 153,
        1430: 313,
        1530: 429,
        1630: 472,
        1730: 410,
        1830: 200,
        1930: 67,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        FIELD3: 73,
        Mean: 10,
        "0330": 25,
        "0430": 50,
        "0530": 71,
        "0630": 89,
        "0730": 105,
        "0830": 116,
        "0930": 126,
        1030: 133,
        1130: 139,
        1230: 145,
        1330: 149,
        1430: 155,
        1530: 154,
        1630: 139,
        1730: 104,
        1830: 52,
        1930: 20,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        FIELD3: 287,
        Mean: 0,
        "0330": 16,
        "0430": 105,
        "0530": 237,
        "0630": 386,
        "0730": 529,
        "0830": 651,
        "0930": 739,
        1030: 785,
        1130: 785,
        1230: 739,
        1330: 651,
        1430: 529,
        1530: 386,
        1630: 237,
        1730: 105,
        1830: 16,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        FIELD3: 65,
        Mean: 12,
        "0330": 30,
        "0430": 61,
        "0530": 87,
        "0630": 105,
        "0730": 117,
        "0830": 123,
        "0930": 126,
        1030: 127,
        1130: 127,
        1230: 126,
        1330: 123,
        1430: 117,
        1530: 105,
        1630: 87,
        1730: 61,
        1830: 30,
        1930: 12,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        FIELD3: 352,
        Mean: 12,
        "0330": 46,
        "0430": 166,
        "0530": 324,
        "0630": 491,
        "0730": 646,
        "0830": 774,
        "0930": 865,
        1030: 912,
        1130: 912,
        1230: 865,
        1330: 774,
        1430: 646,
        1530: 491,
        1630: 324,
        1730: 166,
        1830: 46,
        1930: 12,
        2030: 0,
      },
    },
  },
  Jul: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 29,
        "0330": 38,
        "0430": 99,
        "0530": 154,
        "0630": 97,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 97,
        1830: 154,
        1930: 99,
        2030: 38,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 67,
        "0330": 14,
        "0430": 35,
        "0530": 70,
        "0630": 95,
        "0730": 109,
        "0830": 117,
        "0930": 124,
        1030: 129,
        1130: 131,
        1230: 131,
        1330: 129,
        1430: 124,
        1530: 117,
        1630: 109,
        1730: 95,
        1830: 70,
        1930: 35,
        2030: 14,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 81,
        "0330": 62,
        "0430": 185,
        "0530": 400,
        "0630": 467,
        "0730": 425,
        "0830": 310,
        "0930": 149,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 72,
        "0330": 19,
        "0430": 48,
        "0530": 100,
        "0630": 138,
        "0730": 154,
        "0830": 154,
        "0930": 149,
        1030: 144,
        1130: 139,
        1230: 132,
        1330: 125,
        1430: 116,
        1530: 104,
        1630: 89,
        1730: 71,
        1830: 48,
        1930: 23,
        2030: 9,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 134,
        "0330": 50,
        "0430": 163,
        "0530": 412,
        "0630": 564,
        "0730": 616,
        "0830": 580,
        "0930": 472,
        1030: 306,
        1130: 106,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 79,
        "0330": 16,
        "0430": 44,
        "0530": 102,
        "0630": 153,
        "0730": 181,
        "0830": 188,
        "0930": 180,
        1030: 168,
        1130: 156,
        1230: 143,
        1330: 131,
        1430: 117,
        1530: 103,
        1630: 88,
        1730: 69,
        1830: 47,
        1930: 21,
        2030: 8,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 129,
        "0330": 9,
        "0430": 45,
        "0530": 182,
        "0630": 330,
        "0730": 446,
        "0830": 511,
        "0930": 518,
        1030: 464,
        1130: 356,
        1230: 205,
        1330: 31,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 11,
        "0430": 29,
        "0530": 73,
        "0630": 119,
        "0730": 157,
        "0830": 178,
        "0930": 186,
        1030: 182,
        1130: 174,
        1230: 162,
        1330: 148,
        1430: 129,
        1530: 109,
        1630: 90,
        1730: 69,
        1830: 47,
        1930: 22,
        2030: 9,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 97,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 15,
        "0830": 143,
        "0930": 260,
        1030: 350,
        1130: 397,
        1230: 397,
        1330: 350,
        1430: 260,
        1530: 143,
        1630: 15,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 75,
        "0330": 8,
        "0430": 21,
        "0530": 49,
        "0630": 80,
        "0730": 111,
        "0830": 138,
        "0930": 159,
        1030: 172,
        1130: 177,
        1230: 177,
        1330: 172,
        1430: 159,
        1530: 138,
        1630: 111,
        1730: 80,
        1830: 49,
        1930: 21,
        2030: 8,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 129,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 31,
        1130: 205,
        1230: 356,
        1330: 464,
        1430: 518,
        1530: 511,
        1630: 446,
        1730: 330,
        1830: 182,
        1930: 45,
        2030: 9,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 9,
        "0430": 22,
        "0530": 47,
        "0630": 69,
        "0730": 90,
        "0830": 109,
        "0930": 129,
        1030: 148,
        1130: 162,
        1230: 174,
        1330: 182,
        1430: 186,
        1530: 178,
        1630: 157,
        1730: 119,
        1830: 73,
        1930: 29,
        2030: 11,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 134,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 106,
        1330: 306,
        1430: 472,
        1530: 580,
        1630: 616,
        1730: 564,
        1830: 412,
        1930: 163,
        2030: 50,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 79,
        "0330": 8,
        "0430": 21,
        "0530": 47,
        "0630": 69,
        "0730": 88,
        "0830": 103,
        "0930": 117,
        1030: 131,
        1130: 143,
        1230: 156,
        1330: 168,
        1430: 180,
        1530: 188,
        1630: 181,
        1730: 153,
        1830: 102,
        1930: 44,
        2030: 16,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 81,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 149,
        1530: 310,
        1630: 425,
        1730: 467,
        1830: 400,
        1930: 185,
        2030: 62,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 72,
        "0330": 9,
        "0430": 23,
        "0530": 48,
        "0630": 71,
        "0730": 89,
        "0830": 104,
        "0930": 116,
        1030: 125,
        1130: 132,
        1230: 139,
        1330: 144,
        1430: 149,
        1530: 154,
        1630: 154,
        1730: 138,
        1830: 100,
        1930: 48,
        2030: 19,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 284,
        "0330": 0,
        "0430": 14,
        "0530": 99,
        "0630": 231,
        "0730": 380,
        "0830": 523,
        "0930": 646,
        1030: 734,
        1130: 780,
        1230: 780,
        1330: 734,
        1430: 646,
        1530: 523,
        1630: 380,
        1730: 231,
        1830: 99,
        1930: 14,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 64,
        "0330": 11,
        "0430": 28,
        "0530": 59,
        "0630": 86,
        "0730": 105,
        "0830": 117,
        "0930": 123,
        1030: 126,
        1130: 126,
        1230: 126,
        1330: 126,
        1430: 123,
        1530: 117,
        1630: 105,
        1730: 86,
        1830: 59,
        1930: 28,
        2030: 11,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 348,
        "0330": 11,
        "0430": 42,
        "0530": 158,
        "0630": 317,
        "0730": 485,
        "0830": 640,
        "0930": 769,
        1030: 860,
        1130: 906,
        1230: 906,
        1330: 860,
        1430: 769,
        1530: 640,
        1630: 485,
        1730: 317,
        1830: 158,
        1930: 42,
        2030: 11,
      },
    },
  },
  Aug: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 14,
        "0330": 0,
        "0430": 49,
        "0530": 97,
        "0630": 52,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 52,
        1830: 97,
        1930: 49,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 59,
        "0330": 0,
        "0430": 22,
        "0530": 51,
        "0630": 79,
        "0730": 97,
        "0830": 108,
        "0930": 116,
        1030: 122,
        1130: 125,
        1230: 125,
        1330: 122,
        1430: 116,
        1530: 108,
        1630: 97,
        1730: 79,
        1830: 51,
        1930: 22,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 63,
        "0330": 0,
        "0430": 109,
        "0530": 296,
        "0630": 409,
        "0730": 385,
        "0830": 273,
        "0930": 111,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 64,
        "0330": 0,
        "0430": 31,
        "0530": 75,
        "0630": 118,
        "0730": 140,
        "0830": 145,
        "0930": 142,
        1030: 137,
        1130: 132,
        1230: 126,
        1330: 120,
        1430: 110,
        1530: 98,
        1630: 81,
        1730: 60,
        1830: 36,
        1930: 15,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 124,
        "0330": 0,
        "0430": 105,
        "0530": 321,
        "0630": 526,
        "0730": 605,
        "0830": 583,
        "0930": 478,
        1030: 312,
        1130: 108,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 72,
        "0330": 0,
        "0430": 30,
        "0530": 78,
        "0630": 135,
        "0730": 172,
        "0830": 184,
        "0930": 179,
        1030: 166,
        1130: 152,
        1230: 139,
        1330: 125,
        1430: 112,
        1530: 97,
        1630: 81,
        1730: 61,
        1830: 36,
        1930: 14,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 139,
        "0330": 0,
        "0430": 40,
        "0530": 158,
        "0630": 335,
        "0730": 472,
        "0830": 551,
        "0930": 565,
        1030: 514,
        1130: 405,
        1230: 252,
        1330: 72,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 74,
        "0330": 0,
        "0430": 21,
        "0530": 57,
        "0630": 108,
        "0730": 152,
        "0830": 180,
        "0930": 190,
        1030: 187,
        1130: 177,
        1230: 163,
        1330: 146,
        1430: 126,
        1530: 105,
        1630: 82,
        1730: 60,
        1830: 35,
        1930: 15,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 122,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 61,
        "0830": 196,
        "0930": 321,
        1030: 415,
        1130: 465,
        1230: 465,
        1330: 415,
        1430: 321,
        1530: 196,
        1630: 61,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 73,
        "0330": 0,
        "0430": 14,
        "0530": 38,
        "0630": 71,
        "0730": 106,
        "0830": 137,
        "0930": 161,
        1030: 176,
        1130: 182,
        1230: 182,
        1330: 176,
        1430: 161,
        1530: 137,
        1630: 106,
        1730: 71,
        1830: 38,
        1930: 14,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 139,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 72,
        1130: 252,
        1230: 405,
        1330: 514,
        1430: 565,
        1530: 551,
        1630: 472,
        1730: 335,
        1830: 158,
        1930: 40,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 74,
        "0330": 0,
        "0430": 15,
        "0530": 35,
        "0630": 60,
        "0730": 82,
        "0830": 105,
        "0930": 126,
        1030: 146,
        1130: 163,
        1230: 177,
        1330: 187,
        1430: 190,
        1530: 180,
        1630: 152,
        1730: 108,
        1830: 57,
        1930: 21,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 124,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 108,
        1330: 312,
        1430: 478,
        1530: 583,
        1630: 605,
        1730: 526,
        1830: 321,
        1930: 105,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 72,
        "0330": 0,
        "0430": 14,
        "0530": 36,
        "0630": 61,
        "0730": 81,
        "0830": 97,
        "0930": 112,
        1030: 125,
        1130: 139,
        1230: 152,
        1330: 166,
        1430: 179,
        1530: 184,
        1630: 172,
        1730: 135,
        1830: 78,
        1930: 30,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 63,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 111,
        1530: 273,
        1630: 385,
        1730: 409,
        1830: 296,
        1930: 109,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 64,
        "0330": 0,
        "0430": 15,
        "0530": 36,
        "0630": 60,
        "0730": 81,
        "0830": 98,
        "0930": 110,
        1030: 120,
        1130: 126,
        1230: 132,
        1330: 137,
        1430: 142,
        1530: 145,
        1630: 140,
        1730: 118,
        1830: 75,
        1930: 31,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 249,
        "0330": 0,
        "0430": 4,
        "0530": 50,
        "0630": 170,
        "0730": 317,
        "0830": 462,
        "0930": 587,
        1030: 678,
        1130: 726,
        1230: 726,
        1330: 678,
        1430: 587,
        1530: 462,
        1630: 317,
        1730: 170,
        1830: 50,
        1930: 4,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 59,
        "0330": 0,
        "0430": 19,
        "0530": 45,
        "0630": 75,
        "0730": 98,
        "0830": 113,
        "0930": 121,
        1030: 125,
        1130: 126,
        1230: 126,
        1330: 125,
        1430: 121,
        1530: 113,
        1630: 98,
        1730: 75,
        1830: 45,
        1930: 19,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 309,
        "0330": 0,
        "0430": 23,
        "0530": 95,
        "0630": 245,
        "0730": 415,
        "0830": 575,
        "0930": 708,
        1030: 803,
        1130: 852,
        1230: 852,
        1330: 803,
        1430: 708,
        1530: 575,
        1630: 415,
        1730: 245,
        1830: 95,
        1930: 23,
        2030: 0,
      },
    },
  },
  Sep: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 1,
        "0330": 0,
        "0430": 0,
        "0530": 20,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 20,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 46,
        "0330": 0,
        "0430": 0,
        "0530": 22,
        "0630": 49,
        "0730": 73,
        "0830": 90,
        "0930": 101,
        1030: 109,
        1130: 113,
        1230: 113,
        1330: 109,
        1430: 101,
        1530: 90,
        1630: 74,
        1730: 49,
        1830: 22,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 37,
        "0330": 0,
        "0430": 0,
        "0530": 117,
        "0630": 272,
        "0730": 297,
        "0830": 203,
        "0930": 45,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 51,
        "0330": 0,
        "0430": 0,
        "0530": 35,
        "0630": 76,
        "0730": 110,
        "0830": 124,
        "0930": 124,
        1030: 122,
        1130: 119,
        1230: 114,
        1330: 108,
        1430: 98,
        1530: 84,
        1630: 65,
        1730: 40,
        1830: 17,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 103,
        "0330": 0,
        "0430": 0,
        "0530": 145,
        "0630": 392,
        "0730": 545,
        "0830": 559,
        "0930": 471,
        1030: 312,
        1130: 109,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 60,
        "0330": 0,
        "0430": 0,
        "0530": 40,
        "0630": 93,
        "0730": 145,
        "0830": 169,
        "0930": 169,
        1030: 159,
        1130: 144,
        1230: 129,
        1330: 114,
        1430: 99,
        1530: 84,
        1630: 65,
        1730: 41,
        1830: 18,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 147,
        "0330": 0,
        "0430": 0,
        "0530": 89,
        "0630": 282,
        "0730": 475,
        "0830": 587,
        "0930": 622,
        1030: 582,
        1130: 477,
        1230: 323,
        1330: 141,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 67,
        "0330": 0,
        "0430": 0,
        "0530": 30,
        "0630": 77,
        "0730": 134,
        "0830": 173,
        "0930": 190,
        1030: 191,
        1130: 180,
        1230: 163,
        1330: 143,
        1430: 118,
        1530: 93,
        1630: 67,
        1730: 40,
        1830: 17,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 157,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 8,
        "0730": 126,
        "0830": 271,
        "0930": 408,
        1030: 511,
        1130: 565,
        1230: 565,
        1330: 511,
        1430: 408,
        1530: 271,
        1630: 125,
        1730: 8,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 68,
        "0330": 0,
        "0430": 0,
        "0530": 20,
        "0630": 50,
        "0730": 92,
        "0830": 131,
        "0930": 161,
        1030: 182,
        1130: 191,
        1230: 191,
        1330: 182,
        1430: 161,
        1530: 131,
        1630: 92,
        1730: 50,
        1830: 20,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 147,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 141,
        1130: 323,
        1230: 477,
        1330: 582,
        1430: 622,
        1530: 587,
        1630: 474,
        1730: 282,
        1830: 89,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 67,
        "0330": 0,
        "0430": 0,
        "0530": 17,
        "0630": 40,
        "0730": 67,
        "0830": 93,
        "0930": 118,
        1030: 143,
        1130: 163,
        1230: 180,
        1330: 191,
        1430: 190,
        1530: 173,
        1630: 134,
        1730: 77,
        1830: 30,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 103,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 109,
        1330: 312,
        1430: 471,
        1530: 559,
        1630: 546,
        1730: 392,
        1830: 145,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 60,
        "0330": 0,
        "0430": 0,
        "0530": 18,
        "0630": 41,
        "0730": 65,
        "0830": 84,
        "0930": 99,
        1030: 114,
        1130: 129,
        1230: 144,
        1330: 159,
        1430: 169,
        1530: 169,
        1630: 145,
        1730: 93,
        1830: 40,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 37,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 45,
        1530: 203,
        1630: 297,
        1730: 272,
        1830: 117,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 51,
        "0330": 0,
        "0430": 0,
        "0530": 17,
        "0630": 40,
        "0730": 65,
        "0830": 84,
        "0930": 98,
        1030: 108,
        1130: 114,
        1230: 119,
        1330: 122,
        1430: 124,
        1530: 124,
        1630: 110,
        1730: 76,
        1830: 35,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 189,
        "0330": 0,
        "0430": 0,
        "0530": 7,
        "0630": 71,
        "0730": 202,
        "0830": 343,
        "0930": 469,
        1030: 562,
        1130: 611,
        1230: 611,
        1330: 562,
        1430: 469,
        1530: 343,
        1630: 202,
        1730: 71,
        1830: 7,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 51,
        "0330": 0,
        "0430": 0,
        "0530": 23,
        "0630": 52,
        "0730": 82,
        "0830": 102,
        "0930": 114,
        1030: 121,
        1130: 123,
        1230: 123,
        1330: 121,
        1430: 114,
        1530: 102,
        1630: 82,
        1730: 52,
        1830: 23,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 239,
        "0330": 0,
        "0430": 0,
        "0530": 30,
        "0630": 123,
        "0730": 284,
        "0830": 445,
        "0930": 583,
        1030: 683,
        1130: 734,
        1230: 734,
        1330: 683,
        1430: 583,
        1530: 445,
        1630: 284,
        1730: 123,
        1830: 30,
        1930: 0,
        2030: 0,
      },
    },
  },
  Oct: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 33,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 20,
        "0730": 45,
        "0830": 67,
        "0930": 81,
        1030: 92,
        1130: 96,
        1230: 96,
        1330: 92,
        1430: 81,
        1530: 67,
        1630: 45,
        1730: 20,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 14,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 91,
        "0730": 171,
        "0830": 117,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 36,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 32,
        "0730": 67,
        "0830": 91,
        "0930": 99,
        1030: 102,
        1130: 100,
        1230: 97,
        1330: 91,
        1430: 81,
        1530: 66,
        1630: 43,
        1730: 19,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 74,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 159,
        "0730": 384,
        "0830": 473,
        "0930": 424,
        1030: 288,
        1130: 102,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 45,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 42,
        "0730": 94,
        "0830": 133,
        "0930": 145,
        1030: 141,
        1130: 128,
        1230: 113,
        1330: 98,
        1430: 82,
        1530: 65,
        1630: 43,
        1730: 19,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 140,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 133,
        "0730": 372,
        "0830": 552,
        "0930": 623,
        1030: 607,
        1130: 517,
        1230: 373,
        1330: 199,
        1430: 24,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 55,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 38,
        "0730": 93,
        "0830": 145,
        "0930": 174,
        1030: 183,
        1130: 175,
        1230: 156,
        1330: 132,
        1430: 103,
        1530: 74,
        1630: 44,
        1730: 19,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 177,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 30,
        "0730": 142,
        "0830": 307,
        "0930": 457,
        1030: 570,
        1130: 629,
        1230: 629,
        1330: 570,
        1430: 457,
        1530: 307,
        1630: 142,
        1730: 30,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 59,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 25,
        "0730": 64,
        "0830": 111,
        "0930": 150,
        1030: 178,
        1130: 191,
        1230: 191,
        1330: 178,
        1430: 150,
        1530: 111,
        1630: 64,
        1730: 25,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 140,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 24,
        1030: 199,
        1130: 373,
        1230: 517,
        1330: 607,
        1430: 623,
        1530: 552,
        1630: 372,
        1730: 133,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 55,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 19,
        "0730": 44,
        "0830": 74,
        "0930": 103,
        1030: 132,
        1130: 156,
        1230: 175,
        1330: 183,
        1430: 174,
        1530: 145,
        1630: 93,
        1730: 38,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 74,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 102,
        1330: 288,
        1430: 424,
        1530: 473,
        1630: 384,
        1730: 159,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 45,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 19,
        "0730": 43,
        "0830": 65,
        "0930": 82,
        1030: 98,
        1130: 113,
        1230: 128,
        1330: 141,
        1430: 145,
        1530: 133,
        1630: 94,
        1730: 42,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 14,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 117,
        1630: 171,
        1730: 91,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 36,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 19,
        "0730": 43,
        "0830": 66,
        "0930": 81,
        1030: 91,
        1130: 97,
        1230: 100,
        1330: 102,
        1430: 99,
        1530: 91,
        1630: 67,
        1730: 32,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 121,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 9,
        "0730": 78,
        "0830": 198,
        "0930": 314,
        1030: 403,
        1130: 450,
        1230: 450,
        1330: 403,
        1430: 314,
        1530: 198,
        1630: 78,
        1730: 9,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 40,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 25,
        "0730": 55,
        "0830": 82,
        "0930": 99,
        1030: 110,
        1130: 114,
        1230: 114,
        1330: 110,
        1430: 99,
        1530: 82,
        1630: 55,
        1730: 25,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 160,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 34,
        "0730": 133,
        "0830": 280,
        "0930": 413,
        1030: 513,
        1130: 564,
        1230: 564,
        1330: 513,
        1430: 413,
        1530: 280,
        1630: 133,
        1730: 34,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
  },
  Nov: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 22,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 19,
        "0830": 41,
        "0930": 59,
        1030: 72,
        1130: 78,
        1230: 78,
        1330: 72,
        1430: 59,
        1530: 41,
        1630: 19,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 3,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 47,
        "0830": 41,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 23,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 26,
        "0830": 53,
        "0930": 70,
        1030: 77,
        1130: 80,
        1230: 78,
        1330: 72,
        1430: 60,
        1530: 42,
        1630: 19,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 44,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 145,
        "0830": 308,
        "0930": 329,
        1030: 238,
        1130: 85,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 30,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 40,
        "0830": 82,
        "0930": 106,
        1030: 111,
        1130: 105,
        1230: 92,
        1330: 77,
        1430: 60,
        1530: 41,
        1630: 19,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 115,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 158,
        "0830": 395,
        "0930": 533,
        1030: 557,
        1130: 495,
        1230: 374,
        1330: 220,
        1430: 67,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 40,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 42,
        "0830": 94,
        "0930": 135,
        1030: 153,
        1130: 152,
        1230: 136,
        1330: 110,
        1430: 79,
        1530: 48,
        1630: 20,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 158,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 79,
        "0830": 250,
        "0930": 425,
        1030: 549,
        1130: 614,
        1230: 614,
        1330: 549,
        1430: 425,
        1530: 250,
        1630: 79,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 45,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 30,
        "0830": 74,
        "0930": 119,
        1030: 152,
        1130: 170,
        1230: 170,
        1330: 152,
        1430: 119,
        1530: 74,
        1630: 30,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 115,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 67,
        1030: 220,
        1130: 374,
        1230: 495,
        1330: 557,
        1430: 533,
        1530: 395,
        1630: 158,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 40,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 20,
        "0830": 48,
        "0930": 79,
        1030: 110,
        1130: 136,
        1230: 152,
        1330: 153,
        1430: 135,
        1530: 94,
        1630: 42,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 44,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 85,
        1330: 238,
        1430: 329,
        1530: 308,
        1630: 145,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 30,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 19,
        "0830": 41,
        "0930": 60,
        1030: 77,
        1130: 92,
        1230: 105,
        1330: 111,
        1430: 106,
        1530: 82,
        1630: 40,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 3,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 41,
        1630: 47,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 23,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 19,
        "0830": 42,
        "0930": 60,
        1030: 72,
        1130: 78,
        1230: 80,
        1330: 77,
        1430: 70,
        1530: 53,
        1630: 26,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 63,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 9,
        "0830": 70,
        "0930": 161,
        1030: 237,
        1130: 279,
        1230: 279,
        1330: 237,
        1430: 161,
        1530: 70,
        1630: 9,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 28,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 25,
        "0830": 53,
        "0930": 75,
        1030: 89,
        1130: 96,
        1230: 96,
        1330: 89,
        1430: 75,
        1530: 53,
        1630: 25,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 90,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 34,
        "0830": 123,
        "0930": 236,
        1030: 326,
        1130: 375,
        1230: 375,
        1330: 326,
        1430: 236,
        1530: 123,
        1630: 34,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
  },
  Dec: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 15,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 10,
        "0830": 23,
        "0930": 42,
        1030: 56,
        1130: 62,
        1230: 62,
        1330: 56,
        1430: 42,
        1530: 23,
        1630: 10,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 11,
        "0830": 9,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 16,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 12,
        "0830": 29,
        "0930": 48,
        1030: 59,
        1130: 62,
        1230: 61,
        1330: 56,
        1430: 43,
        1530: 24,
        1630: 10,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 27,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 57,
        "0830": 151,
        "0930": 237,
        1030: 189,
        1130: 70,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 20,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 19,
        "0830": 44,
        "0930": 74,
        1030: 86,
        1130: 82,
        1230: 72,
        1330: 60,
        1430: 43,
        1530: 23,
        1630: 10,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 89,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 70,
        "0830": 204,
        "0930": 408,
        1030: 472,
        1130: 439,
        1230: 339,
        1330: 205,
        1430: 72,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 28,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 22,
        "0830": 53,
        "0930": 98,
        1030: 122,
        1130: 123,
        1230: 110,
        1330: 87,
        1430: 58,
        1530: 27,
        1630: 11,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 126,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 42,
        "0830": 138,
        "0930": 339,
        1030: 479,
        1130: 550,
        1230: 550,
        1330: 479,
        1430: 339,
        1530: 138,
        1630: 42,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 33,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 16,
        "0830": 42,
        "0930": 87,
        1030: 123,
        1130: 140,
        1230: 140,
        1330: 123,
        1430: 87,
        1530: 42,
        1630: 16,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 89,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 72,
        1030: 205,
        1130: 339,
        1230: 439,
        1330: 472,
        1430: 408,
        1530: 204,
        1630: 70,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 28,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 11,
        "0830": 27,
        "0930": 58,
        1030: 87,
        1130: 110,
        1230: 123,
        1330: 122,
        1430: 98,
        1530: 53,
        1630: 22,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 27,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 70,
        1330: 189,
        1430: 237,
        1530: 151,
        1630: 57,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 20,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 10,
        "0830": 23,
        "0930": 43,
        1030: 60,
        1130: 72,
        1230: 82,
        1330: 86,
        1430: 74,
        1530: 44,
        1630: 19,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 9,
        1630: 11,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 16,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 10,
        "0830": 24,
        "0930": 43,
        1030: 56,
        1130: 61,
        1230: 62,
        1330: 59,
        1430: 48,
        1530: 29,
        1630: 12,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 34,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 15,
        "0930": 77,
        1030: 138,
        1130: 174,
        1230: 174,
        1330: 138,
        1430: 77,
        1530: 15,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 20,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 13,
        "0830": 30,
        "0930": 55,
        1030: 71,
        1130: 78,
        1230: 78,
        1330: 71,
        1430: 55,
        1530: 30,
        1630: 13,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 53,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 13,
        "0830": 45,
        "0930": 132,
        1030: 209,
        1130: 252,
        1230: 252,
        1330: 209,
        1430: 132,
        1530: 45,
        1630: 13,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
  },
  Jan: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 19,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 16,
        "0830": 34,
        "0930": 54,
        1030: 66,
        1130: 73,
        1230: 73,
        1330: 66,
        1430: 54,
        1530: 34,
        1630: 16,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 2,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 29,
        "0830": 26,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 21,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 22,
        "0830": 44,
        "0930": 62,
        1030: 70,
        1130: 73,
        1230: 72,
        1330: 66,
        1430: 55,
        1530: 36,
        1630: 17,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 38,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 105,
        "0830": 252,
        "0930": 298,
        1030: 221,
        1130: 81,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 26,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 33,
        "0830": 68,
        "0930": 95,
        1030: 102,
        1130: 97,
        1230: 85,
        1330: 70,
        1430: 54,
        1530: 34,
        1630: 17,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 106,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 121,
        "0830": 330,
        "0930": 495,
        1030: 532,
        1130: 480,
        1230: 366,
        1330: 219,
        1430: 73,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 36,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 36,
        "0830": 80,
        "0930": 122,
        1030: 142,
        1130: 143,
        1230: 127,
        1330: 102,
        1430: 72,
        1530: 41,
        1630: 18,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 148,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 65,
        "0830": 215,
        "0930": 402,
        1030: 532,
        1130: 598,
        1230: 598,
        1330: 532,
        1430: 402,
        1530: 215,
        1630: 65,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 41,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 27,
        "0830": 63,
        "0930": 109,
        1030: 142,
        1130: 161,
        1230: 161,
        1330: 142,
        1430: 109,
        1530: 63,
        1630: 27,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 106,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 73,
        1030: 219,
        1130: 366,
        1230: 480,
        1330: 532,
        1430: 495,
        1530: 330,
        1630: 121,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 36,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 18,
        "0830": 41,
        "0930": 72,
        1030: 102,
        1130: 127,
        1230: 143,
        1330: 142,
        1430: 122,
        1530: 80,
        1630: 36,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 38,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 81,
        1330: 221,
        1430: 298,
        1530: 252,
        1630: 105,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 26,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 17,
        "0830": 34,
        "0930": 54,
        1030: 70,
        1130: 85,
        1230: 97,
        1330: 102,
        1430: 95,
        1530: 68,
        1630: 33,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 2,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 26,
        1630: 29,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 21,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 17,
        "0830": 36,
        "0930": 55,
        1030: 66,
        1130: 72,
        1230: 73,
        1330: 70,
        1430: 62,
        1530: 44,
        1630: 22,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 51,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 4,
        "0830": 44,
        "0930": 127,
        1030: 198,
        1130: 238,
        1230: 238,
        1330: 198,
        1430: 127,
        1530: 44,
        1630: 4,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 25,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 21,
        "0830": 45,
        "0930": 68,
        1030: 83,
        1130: 90,
        1230: 90,
        1330: 83,
        1430: 68,
        1530: 45,
        1630: 21,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 75,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 25,
        "0830": 89,
        "0930": 195,
        1030: 281,
        1130: 328,
        1230: 328,
        1330: 281,
        1430: 195,
        1530: 89,
        1630: 25,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
  },
  Feb: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 29,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 14,
        "0730": 33,
        "0830": 58,
        "0930": 73,
        1030: 84,
        1130: 90,
        1230: 90,
        1330: 84,
        1430: 73,
        1530: 58,
        1630: 33,
        1730: 14,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 9,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 49,
        "0730": 114,
        "0830": 84,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 31,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 21,
        "0730": 49,
        "0830": 78,
        "0930": 89,
        1030: 93,
        1130: 93,
        1230: 90,
        1330: 84,
        1430: 74,
        1530: 58,
        1630: 33,
        1730: 13,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 62,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 96,
        "0730": 283,
        "0830": 420,
        "0930": 395,
        1030: 274,
        1130: 97,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 39,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 29,
        "0730": 70,
        "0830": 116,
        "0930": 133,
        1030: 131,
        1130: 121,
        1230: 106,
        1330: 90,
        1430: 74,
        1530: 57,
        1630: 33,
        1730: 14,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 133,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 87,
        "0730": 286,
        "0830": 510,
        "0930": 606,
        1030: 603,
        1130: 522,
        1230: 385,
        1330: 216,
        1430: 47,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 50,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 27,
        "0730": 71,
        "0830": 129,
        "0930": 164,
        1030: 175,
        1130: 169,
        1230: 151,
        1330: 125,
        1430: 96,
        1530: 66,
        1630: 34,
        1730: 13,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 176,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 27,
        "0730": 121,
        "0830": 301,
        "0930": 461,
        1030: 579,
        1130: 641,
        1230: 641,
        1330: 579,
        1430: 461,
        1530: 301,
        1630: 121,
        1730: 27,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 55,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 18,
        "0730": 50,
        "0830": 100,
        "0930": 142,
        1030: 171,
        1130: 187,
        1230: 187,
        1330: 171,
        1430: 142,
        1530: 100,
        1630: 50,
        1730: 18,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 133,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 47,
        1030: 216,
        1130: 385,
        1230: 522,
        1330: 603,
        1430: 606,
        1530: 510,
        1630: 286,
        1730: 87,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 50,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 13,
        "0730": 34,
        "0830": 66,
        "0930": 96,
        1030: 125,
        1130: 151,
        1230: 169,
        1330: 175,
        1430: 164,
        1530: 129,
        1630: 71,
        1730: 27,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 62,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 97,
        1330: 274,
        1430: 395,
        1530: 420,
        1630: 283,
        1730: 96,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 39,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 14,
        "0730": 33,
        "0830": 57,
        "0930": 74,
        1030: 90,
        1130: 106,
        1230: 121,
        1330: 131,
        1430: 133,
        1530: 116,
        1630: 70,
        1730: 29,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 9,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 84,
        1630: 114,
        1730: 49,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 31,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 13,
        "0730": 33,
        "0830": 58,
        "0930": 74,
        1030: 84,
        1130: 90,
        1230: 93,
        1330: 93,
        1430: 89,
        1530: 78,
        1630: 49,
        1730: 21,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 96,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 2,
        "0730": 38,
        "0830": 143,
        "0930": 252,
        1030: 337,
        1130: 383,
        1230: 383,
        1330: 337,
        1430: 252,
        1530: 143,
        1630: 38,
        1730: 2,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 35,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 17,
        "0730": 42,
        "0830": 72,
        "0930": 92,
        1030: 103,
        1130: 109,
        1230: 109,
        1330: 103,
        1430: 92,
        1530: 72,
        1630: 42,
        1730: 17,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 131,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 19,
        "0730": 80,
        "0830": 215,
        "0930": 344,
        1030: 440,
        1130: 492,
        1230: 492,
        1330: 440,
        1430: 344,
        1530: 215,
        1630: 80,
        1730: 19,
        1830: 0,
        1930: 0,
        2030: 0,
      },
    },
  },
  Mar: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 0,
        "0330": 0,
        "0430": 0,
        "0530": 7,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 7,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 42,
        "0330": 0,
        "0430": 0,
        "0530": 16,
        "0630": 39,
        "0730": 66,
        "0830": 84,
        "0930": 96,
        1030: 105,
        1130: 110,
        1230: 110,
        1330: 105,
        1430: 96,
        1530: 84,
        1630: 66,
        1730: 39,
        1830: 16,
        1930: 0,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 29,
        "0330": 0,
        "0430": 0,
        "0530": 74,
        "0630": 209,
        "0730": 263,
        "0830": 178,
        "0930": 21,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 47,
        "0330": 0,
        "0430": 0,
        "0530": 25,
        "0630": 60,
        "0730": 99,
        "0830": 116,
        "0930": 119,
        1030: 118,
        1130: 115,
        1230: 111,
        1330: 105,
        1430: 94,
        1530: 80,
        1630: 59,
        1730: 32,
        1830: 13,
        1930: 0,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 95,
        "0330": 0,
        "0430": 0,
        "0530": 99,
        "0630": 315,
        "0730": 514,
        "0830": 547,
        "0930": 467,
        1030: 311,
        1130: 109,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 56,
        "0330": 0,
        "0430": 0,
        "0530": 29,
        "0630": 76,
        "0730": 133,
        "0830": 162,
        "0930": 166,
        1030: 157,
        1130: 142,
        1230: 126,
        1330: 111,
        1430: 96,
        1530: 79,
        1630: 60,
        1730: 34,
        1830: 14,
        1930: 0,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 149,
        "0330": 0,
        "0430": 0,
        "0530": 65,
        "0630": 237,
        "0730": 463,
        "0830": 595,
        "0930": 639,
        1030: 604,
        1130: 502,
        1230: 348,
        1330: 164,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 64,
        "0330": 0,
        "0430": 0,
        "0530": 23,
        "0630": 64,
        "0730": 125,
        "0830": 169,
        "0930": 191,
        1030: 194,
        1130: 183,
        1230: 165,
        1330: 142,
        1430: 116,
        1530: 89,
        1630: 61,
        1730: 32,
        1830: 13,
        1930: 0,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 170,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 20,
        "0730": 141,
        "0830": 294,
        "0930": 437,
        1030: 544,
        1130: 601,
        1230: 601,
        1330: 544,
        1430: 437,
        1530: 294,
        1630: 141,
        1730: 19,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 67,
        "0330": 0,
        "0430": 0,
        "0530": 15,
        "0630": 41,
        "0730": 86,
        "0830": 128,
        "0930": 162,
        1030: 185,
        1130: 196,
        1230: 196,
        1330: 185,
        1430: 162,
        1530: 128,
        1630: 86,
        1730: 41,
        1830: 15,
        1930: 0,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 149,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 164,
        1130: 348,
        1230: 502,
        1330: 604,
        1430: 639,
        1530: 595,
        1630: 463,
        1730: 236,
        1830: 65,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 64,
        "0330": 0,
        "0430": 0,
        "0530": 13,
        "0630": 32,
        "0730": 61,
        "0830": 89,
        "0930": 116,
        1030: 142,
        1130: 165,
        1230: 183,
        1330: 194,
        1430: 191,
        1530: 169,
        1630: 125,
        1730: 64,
        1830: 23,
        1930: 0,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 95,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 109,
        1330: 311,
        1430: 467,
        1530: 547,
        1630: 514,
        1730: 315,
        1830: 99,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 56,
        "0330": 0,
        "0430": 0,
        "0530": 14,
        "0630": 34,
        "0730": 60,
        "0830": 79,
        "0930": 96,
        1030: 111,
        1130: 126,
        1230: 142,
        1330: 157,
        1430: 166,
        1530: 162,
        1630: 133,
        1730: 76,
        1830: 29,
        1930: 0,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 29,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 21,
        1530: 178,
        1630: 263,
        1730: 209,
        1830: 74,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 47,
        "0330": 0,
        "0430": 0,
        "0530": 13,
        "0630": 32,
        "0730": 59,
        "0830": 80,
        "0930": 94,
        1030: 105,
        1130: 111,
        1230: 115,
        1330: 118,
        1430: 119,
        1530: 116,
        1630: 99,
        1730: 60,
        1830: 25,
        1930: 0,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 168,
        "0330": 0,
        "0430": 0,
        "0530": 2,
        "0630": 41,
        "0730": 162,
        "0830": 301,
        "0930": 427,
        1030: 520,
        1130: 569,
        1230: 569,
        1330: 520,
        1430: 427,
        1530: 301,
        1630: 162,
        1730: 41,
        1830: 2,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 48,
        "0330": 0,
        "0430": 0,
        "0530": 17,
        "0630": 43,
        "0730": 75,
        "0830": 98,
        "0930": 112,
        1030: 120,
        1130: 123,
        1230: 123,
        1330: 120,
        1430: 112,
        1530: 98,
        1630: 75,
        1730: 43,
        1830: 17,
        1930: 0,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 216,
        "0330": 0,
        "0430": 0,
        "0530": 19,
        "0630": 84,
        "0730": 237,
        "0830": 399,
        "0930": 539,
        1030: 640,
        1130: 692,
        1230: 692,
        1330: 640,
        1430: 539,
        1530: 399,
        1630: 237,
        1730: 84,
        1830: 19,
        1930: 0,
        2030: 0,
      },
    },
  },
  Apr: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 9,
        "0330": 0,
        "0430": 30,
        "0530": 68,
        "0630": 32,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 32,
        1830: 68,
        1930: 30,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 55,
        "0330": 0,
        "0430": 17,
        "0530": 40,
        "0630": 71,
        "0730": 91,
        "0830": 103,
        "0930": 113,
        1030: 120,
        1130: 123,
        1230: 123,
        1330: 120,
        1430: 113,
        1530: 103,
        1630: 91,
        1730: 71,
        1830: 40,
        1930: 17,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 55,
        "0330": 0,
        "0430": 75,
        "0530": 229,
        "0630": 377,
        "0730": 364,
        "0830": 256,
        "0930": 92,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 61,
        "0330": 0,
        "0430": 25,
        "0530": 60,
        "0630": 108,
        "0730": 133,
        "0830": 140,
        "0930": 139,
        1030: 135,
        1130: 130,
        1230: 125,
        1330: 118,
        1430: 108,
        1530: 94,
        1630: 77,
        1730: 55,
        1830: 29,
        1930: 12,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 120,
        "0330": 0,
        "0430": 76,
        "0530": 257,
        "0630": 502,
        "0730": 601,
        "0830": 587,
        "0930": 484,
        1030: 318,
        1130: 110,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 70,
        "0330": 0,
        "0430": 25,
        "0530": 64,
        "0630": 126,
        "0730": 167,
        "0830": 182,
        "0930": 179,
        1030: 167,
        1130: 152,
        1230: 138,
        1330: 124,
        1430: 109,
        1530: 94,
        1630: 77,
        1730: 56,
        1830: 29,
        1930: 12,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 145,
        "0330": 0,
        "0430": 33,
        "0530": 134,
        "0630": 332,
        "0730": 485,
        "0830": 574,
        "0930": 593,
        1030: 545,
        1130: 435,
        1230: 279,
        1330: 95,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 73,
        "0330": 0,
        "0430": 17,
        "0530": 47,
        "0630": 102,
        "0730": 150,
        "0830": 180,
        "0930": 193,
        1030: 192,
        1130: 181,
        1230: 166,
        1330: 148,
        1430: 125,
        1530: 101,
        1630: 79,
        1730: 55,
        1830: 29,
        1930: 12,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 135,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 86,
        "0830": 225,
        "0930": 355,
        1030: 452,
        1130: 505,
        1230: 505,
        1330: 452,
        1430: 355,
        1530: 224,
        1630: 84,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 73,
        "0330": 0,
        "0430": 12,
        "0530": 31,
        "0630": 66,
        "0730": 104,
        "0830": 137,
        "0930": 164,
        1030: 181,
        1130: 188,
        1230: 188,
        1330: 181,
        1430: 164,
        1530: 136,
        1630: 103,
        1730: 66,
        1830: 31,
        1930: 12,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 145,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 95,
        1130: 279,
        1230: 435,
        1330: 545,
        1430: 593,
        1530: 574,
        1630: 485,
        1730: 332,
        1830: 134,
        1930: 33,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 73,
        "0330": 0,
        "0430": 12,
        "0530": 29,
        "0630": 55,
        "0730": 79,
        "0830": 101,
        "0930": 125,
        1030: 148,
        1130: 166,
        1230: 181,
        1330: 192,
        1430: 193,
        1530: 180,
        1630: 150,
        1730: 102,
        1830: 47,
        1930: 17,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 120,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 110,
        1330: 318,
        1430: 484,
        1530: 587,
        1630: 601,
        1730: 502,
        1830: 257,
        1930: 76,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 70,
        "0330": 0,
        "0430": 12,
        "0530": 29,
        "0630": 56,
        "0730": 77,
        "0830": 94,
        "0930": 109,
        1030: 124,
        1130: 138,
        1230: 152,
        1330: 167,
        1430: 179,
        1530: 182,
        1630: 167,
        1730: 126,
        1830: 64,
        1930: 25,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 56,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 92,
        1530: 257,
        1630: 365,
        1730: 377,
        1830: 229,
        1930: 75,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 61,
        "0330": 0,
        "0430": 12,
        "0530": 29,
        "0630": 55,
        "0730": 77,
        "0830": 94,
        "0930": 108,
        1030: 118,
        1130: 125,
        1230: 130,
        1330: 135,
        1430: 139,
        1530: 140,
        1630: 133,
        1730: 108,
        1830: 60,
        1930: 25,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 234,
        "0330": 0,
        "0430": 1,
        "0530": 28,
        "0630": 140,
        "0730": 286,
        "0830": 433,
        "0930": 560,
        1030: 654,
        1130: 702,
        1230: 702,
        1330: 654,
        1430: 560,
        1530: 433,
        1630: 286,
        1730: 140,
        1830: 28,
        1930: 1,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 57,
        "0330": 0,
        "0430": 15,
        "0530": 37,
        "0630": 70,
        "0730": 95,
        "0830": 111,
        "0930": 121,
        1030: 126,
        1130: 127,
        1230: 127,
        1330: 126,
        1430: 121,
        1530: 111,
        1630: 95,
        1730: 70,
        1830: 37,
        1930: 15,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 291,
        "0330": 0,
        "0430": 16,
        "0530": 65,
        "0630": 210,
        "0730": 381,
        "0830": 544,
        "0930": 681,
        1030: 780,
        1130: 829,
        1230: 829,
        1330: 780,
        1430: 681,
        1530: 544,
        1630: 381,
        1730: 210,
        1830: 65,
        1930: 16,
        2030: 0,
      },
    },
  },
  May: {
    N: {
      Direct: {
        Direction: "N",
        Type: "Beam",
        Mean: 26,
        "0330": 0,
        "0430": 87,
        "0530": 143,
        "0630": 88,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 88,
        1830: 143,
        1930: 87,
        2030: 0,
      },
      Diffuse: {
        Type: "Diffuse",
        Mean: 66,
        "0330": 0,
        "0430": 32,
        "0530": 67,
        "0630": 91,
        "0730": 106,
        "0830": 116,
        "0930": 123,
        1030: 128,
        1130: 130,
        1230: 130,
        1330: 128,
        1430: 123,
        1530: 116,
        1630: 106,
        1730: 91,
        1830: 67,
        1930: 32,
        2030: 0,
      },
    },
    NE: {
      Direct: {
        Direction: "NE",
        Type: "Beam",
        Mean: 77,
        "0330": 0,
        "0430": 168,
        "0530": 382,
        "0630": 458,
        "0730": 419,
        "0830": 304,
        "0930": 142,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 71,
        "0330": 0,
        "0430": 45,
        "0530": 97,
        "0630": 134,
        "0730": 151,
        "0830": 153,
        "0930": 149,
        1030: 143,
        1130: 138,
        1230: 132,
        1330: 125,
        1430: 116,
        1530: 103,
        1630: 87,
        1730: 68,
        1830: 47,
        1930: 21,
        2030: 0,
      },
    },
    E: {
      Direct: {
        Direction: "E",
        Type: "Beam",
        Mean: 133,
        "0330": 0,
        "0430": 150,
        "0530": 398,
        "0630": 560,
        "0730": 618,
        "0830": 586,
        "0930": 476,
        1030: 310,
        1130: 107,
        1230: 0,
        1330: 0,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 0,
        "0430": 42,
        "0530": 99,
        "0630": 149,
        "0730": 180,
        "0830": 188,
        "0930": 181,
        1030: 168,
        1130: 156,
        1230: 143,
        1330: 130,
        1430: 117,
        1530: 103,
        1630: 86,
        1730: 67,
        1830: 45,
        1930: 20,
        2030: 0,
      },
    },
    SE: {
      Direct: {
        Direction: "SE",
        Type: "Beam",
        Mean: 132,
        "0330": 0,
        "0430": 45,
        "0530": 181,
        "0630": 334,
        "0730": 456,
        "0830": 524,
        "0930": 532,
        1030: 478,
        1130: 369,
        1230: 217,
        1330: 40,
        1430: 0,
        1530: 0,
        1630: 0,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 0,
        "0430": 28,
        "0530": 71,
        "0630": 117,
        "0730": 156,
        "0830": 180,
        "0930": 188,
        1030: 184,
        1130: 175,
        1230: 163,
        1330: 148,
        1430: 129,
        1530: 109,
        1630: 88,
        1730: 67,
        1830: 45,
        1930: 21,
        2030: 0,
      },
    },
    S: {
      Direct: {
        Direction: "S",
        Type: "Beam",
        Mean: 103,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 26,
        "0830": 156,
        "0930": 276,
        1030: 367,
        1130: 415,
        1230: 415,
        1330: 367,
        1430: 276,
        1530: 156,
        1630: 26,
        1730: 0,
        1830: 0,
        1930: 0,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 75,
        "0330": 0,
        "0430": 20,
        "0530": 48,
        "0630": 78,
        "0730": 110,
        "0830": 139,
        "0930": 161,
        1030: 173,
        1130: 179,
        1230: 179,
        1330: 173,
        1430: 161,
        1530: 139,
        1630: 110,
        1730: 78,
        1830: 48,
        1930: 20,
        2030: 0,
      },
    },
    SW: {
      Direct: {
        Direction: "SW",
        Type: "Beam",
        Mean: 132,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 40,
        1130: 217,
        1230: 369,
        1330: 478,
        1430: 532,
        1530: 524,
        1630: 456,
        1730: 334,
        1830: 181,
        1930: 45,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 0,
        "0430": 21,
        "0530": 45,
        "0630": 67,
        "0730": 88,
        "0830": 109,
        "0930": 129,
        1030: 148,
        1130: 163,
        1230: 175,
        1330: 184,
        1430: 188,
        1530: 180,
        1630: 156,
        1730: 117,
        1830: 71,
        1930: 28,
        2030: 0,
      },
    },
    W: {
      Direct: {
        Direction: "W",
        Type: "Beam",
        Mean: 133,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 107,
        1330: 310,
        1430: 476,
        1530: 586,
        1630: 618,
        1730: 560,
        1830: 398,
        1930: 150,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 78,
        "0330": 0,
        "0430": 20,
        "0530": 45,
        "0630": 67,
        "0730": 86,
        "0830": 103,
        "0930": 117,
        1030: 130,
        1130: 143,
        1230: 156,
        1330: 168,
        1430: 181,
        1530: 188,
        1630: 180,
        1730: 149,
        1830: 99,
        1930: 42,
        2030: 0,
      },
    },
    NW: {
      Direct: {
        Direction: "NW",
        Type: "Beam",
        Mean: 777,
        "0330": 0,
        "0430": 0,
        "0530": 0,
        "0630": 0,
        "0730": 0,
        "0830": 0,
        "0930": 0,
        1030: 0,
        1130: 0,
        1230: 0,
        1330: 0,
        1430: 142,
        1530: 304,
        1630: 419,
        1730: 458,
        1830: 382,
        1930: 168,
        2030: 0,
      },
      Diffuse: {
        Direction: "",
        Type: "Diffuse",
        Mean: 71,
        "0330": 0,
        "0430": 21,
        "0530": 47,
        "0630": 68,
        "0730": 87,
        "0830": 103,
        "0930": 116,
        1030: 125,
        1130: 132,
        1230: 138,
        1330: 143,
        1430: 149,
        1530: 153,
        1630: 151,
        1730: 134,
        1830: 97,
        1930: 45,
        2030: 0,
      },
    },
    Horizontal: {
      Direct: {
        Direction: "Horiz.",
        Type: "Beam",
        Mean: 278,
        "0330": 0,
        "0430": 11,
        "0530": 88,
        "0630": 219,
        "0730": 368,
        "0830": 513,
        "0930": 637,
        1030: 727,
        1130: 773,
        1230: 773,
        1330: 727,
        1430: 637,
        1530: 513,
        1630: 368,
        1730: 219,
        1830: 88,
        1930: 11,
        2030: 0,
      },
      Diffuse: {
        Direction: "Horiz.",
        Type: "Diffuse",
        Mean: 64,
        "0330": 0,
        "0430": 26,
        "0530": 57,
        "0630": 84,
        "0730": 104,
        "0830": 117,
        "0930": 124,
        1030: 126,
        1130: 127,
        1230: 127,
        1330: 126,
        1430: 124,
        1530: 117,
        1630: 104,
        1730: 84,
        1830: 57,
        1930: 26,
        2030: 0,
      },
      Global: {
        Direction: "Horiz.",
        Type: "Global",
        Mean: 341,
        "0330": 0,
        "0430": 37,
        "0530": 145,
        "0630": 303,
        "0730": 472,
        "0830": 630,
        "0930": 761,
        1030: 853,
        1130: 900,
        1230: 900,
        1330: 853,
        1430: 761,
        1530: 630,
        1630: 472,
        1730: 303,
        1830: 145,
        1930: 37,
        2030: 0,
      },
    },
  },
};

